import React from "react";

import { StyledWrapper } from "./actionItem.style";
import useAppContext from "../../../hooks/useAppContext";

const ActionItem = ({ url, icon, text, callback, actionCallback }) => {
  const { axios } = useAppContext();
  const handleClick = (e) => {
    e.preventDefault();
    if (url) {
      axios
        .post(url)
        .then((res) => {
          actionCallback(res.data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      callback();
    }
    e.currentTarget.blur();
  };

  return (
    <StyledWrapper href="#" onClick={handleClick}>
      <img src={icon} alt={text} />
      <span>{text}</span>
    </StyledWrapper>
  );
};

export default ActionItem;
